import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import StudentSidebar from '../components/StudentSidebar';

const StudentDashboard = () => {
  const { currentUser } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [activeTab, setActiveTab] = useState('time'); // 'time' or 'calendar'
  const [date, setDate] = useState(new Date());
  const [calendar, setCalendar] = useState([]);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Generate calendar based on current month
  useEffect(() => {
    generateCalendar();
  }, [date]);

  const generateCalendar = () => {
    const year = date.getFullYear();
    const month = date.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const firstDayIndex = firstDay.getDay();
    const daysInMonth = lastDay.getDate();
    
    const calendarDays = [];
    
    // Add empty slots for days before first day of month
    for (let i = 0; i < firstDayIndex; i++) {
      calendarDays.push(null);
    }
    
    // Add days of month
    for (let day = 1; day <= daysInMonth; day++) {
      calendarDays.push(day);
    }
    
    // Create week rows (7 days per row)
    const weeks = [];
    let week = [];
    
    calendarDays.forEach((day, index) => {
      if (index % 7 === 0 && index > 0) {
        weeks.push(week);
        week = [];
      }
      week.push(day);
      
      if (index === calendarDays.length - 1) {
        weeks.push(week);
      }
    });
    
    setCalendar(weeks);
  };

  const prevMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1));
  };

  const formatMonthYear = () => {
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  const isToday = (day) => {
    const today = new Date();
    return day === today.getDate() && 
           date.getMonth() === today.getMonth() && 
           date.getFullYear() === today.getFullYear();
  };

  const formattedTime = currentTime.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  const formattedDate = currentTime.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F5F7FA' }}>
      <StudentSidebar />
      
      <div style={{ 
        marginLeft: window.innerWidth <= 768 ? '0' : '290px', 
        flex: 1,
        transition: 'margin-left 0.3s ease'
      }}>
        <Header />
        
        <div style={{ padding: window.innerWidth <= 480 ? '20px 15px' : window.innerWidth <= 768 ? '24px 20px' : '32px 40px' }}>
          {/* Welcome Section - Updated to match admin dashboard */}
          <div style={{
            background: 'linear-gradient(135deg, #F04915 0%, #FF6B35 100%)',
            borderRadius: window.innerWidth <= 480 ? 12 : 20,
            padding: window.innerWidth <= 480 ? '24px' : window.innerWidth <= 768 ? '32px' : '40px',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 10px 25px rgba(240, 73, 21, 0.2)',
            marginBottom: window.innerWidth <= 480 ? 24 : 32
          }}>
            {/* Background decoration */}
            <div style={{
              position: 'absolute',
              top: -50,
              right: -50,
              width: window.innerWidth <= 768 ? 150 : 200,
              height: window.innerWidth <= 768 ? 150 : 200,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              zIndex: 1
            }}></div>
            
            <div style={{ position: 'relative', zIndex: 2 }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: window.innerWidth <= 480 ? 'center' : 'flex-start',
                flexDirection: window.innerWidth <= 480 ? 'column' : 'row',
                textAlign: window.innerWidth <= 480 ? 'center' : 'left'
              }}>
                <div>
                  <h1 style={{ 
                    fontSize: window.innerWidth <= 480 ? 24 : window.innerWidth <= 768 ? 28 : 36, 
                    fontWeight: 700, 
                    marginBottom: 8, 
                    margin: 0, 
                    fontFamily: 'Outfit',
                    lineHeight: '1.2'
                  }}>
                    Welcome back, {currentUser?.name || 'Student'}!
                  </h1>
                  <p style={{ 
                    fontSize: window.innerWidth <= 480 ? 14 : 16, 
                    margin: 0, 
                    opacity: 0.9, 
                    fontFamily: 'Outfit' 
                  }}>
                    Student ID: {currentUser?.student_id} | {currentUser?.additional_data?.degree_path || 'Computer Science'}
                  </p>
                </div>
                <div style={{ 
                  textAlign: window.innerWidth <= 480 ? 'center' : 'right',
                  marginTop: window.innerWidth <= 480 ? '16px' : '0'
                }}>
                  <div style={{ 
                    fontSize: window.innerWidth <= 480 ? 12 : 14, 
                    opacity: 0.8, 
                    marginBottom: 4, 
                    fontFamily: 'Outfit' 
                  }}>
                    {formattedDate}
                  </div>
                  <div style={{ 
                    fontSize: window.innerWidth <= 480 ? 18 : 20, 
                    fontWeight: 600, 
                    fontFamily: 'Outfit' 
                  }}>
                    {formattedTime}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Two Widget Containers */}
          <div style={{ 
            display: 'flex', 
            gap: window.innerWidth <= 768 ? 20 : 32, 
            justifyContent: 'center',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
            alignItems: window.innerWidth <= 768 ? 'center' : 'stretch'
          }}>
            {/* Time Widget Container */}
            <div style={{
              width: window.innerWidth <= 480 ? '100%' : window.innerWidth <= 768 ? '100%' : 350,
              maxWidth: window.innerWidth <= 480 ? '400px' : 'none',
              background: 'white',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.06)',
              borderRadius: 12,
              overflow: 'hidden'
            }}>
              {/* Time Header */}
              <div style={{
                background: '#F8F9FA',
                borderBottom: '1px solid #E5E7EB',
                padding: window.innerWidth <= 480 ? '12px 20px' : '16px 24px',
                borderBottom: '2px solid #F04915'
              }}>
                <div style={{
                  color: '#F04915',
                  fontSize: window.innerWidth <= 480 ? 12 : 14,
                  fontWeight: 600,
                  fontFamily: 'Outfit',
                  textAlign: 'center'
                }}>
                  🕐 Current Time
                </div>
              </div>

              {/* Time Content */}
              <div style={{ padding: window.innerWidth <= 480 ? '20px' : '24px' }}>
                <div style={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: window.innerWidth <= 480 ? 16 : 20
                }}>
                  {/* Sun Icon */}
                  <div style={{ marginBottom: window.innerWidth <= 480 ? 12 : 16 }}>
                    <svg width={window.innerWidth <= 480 ? "50" : "60"} height={window.innerWidth <= 480 ? "50" : "60"} viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="24.5" cy="24.5" r="10.5" stroke="#F04915" strokeWidth="2"/>
                      <line x1="24.5" y1="4" x2="24.5" y2="8" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="24.5" y1="41" x2="24.5" y2="45" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="41" y1="24.5" x2="45" y2="24.5" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="4" y1="24.5" x2="8" y2="24.5" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="36.0711" y1="12.9289" x2="38.9497" y2="10.0503" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="10.0503" y1="38.9497" x2="12.9289" y2="36.0711" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="36.0711" y1="36.0711" x2="38.9497" y2="38.9497" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                      <line x1="10.0503" y1="10.0503" x2="12.9289" y2="12.9289" stroke="#F04915" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>

                  {/* Current Time Display */}
                  <div style={{
                    fontSize: window.innerWidth <= 480 ? 24 : 32,
                    fontWeight: 700,
                    color: '#F04915',
                    fontFamily: 'Outfit'
                  }}>
                    {formattedTime}
                  </div>

                  {/* Date Display */}
                  <div style={{
                    fontSize: window.innerWidth <= 480 ? 16 : 18,
                    color: '#252C58',
                    fontFamily: 'Outfit',
                    fontWeight: 500
                  }}>
                    {formattedDate}
                  </div>

                  {/* Real-time Insight */}
                  <div style={{
                    color: '#F04915',
                    opacity: 0.7,
                    fontSize: window.innerWidth <= 480 ? 10 : 12,
                    fontFamily: 'Outfit',
                    fontWeight: 400
                  }}>
                    Realtime Insight
                  </div>
                </div>
              </div>
            </div>

            {/* Calendar Widget Container */}
            <div style={{
              width: window.innerWidth <= 480 ? '100%' : window.innerWidth <= 768 ? '100%' : 350,
              maxWidth: window.innerWidth <= 480 ? '400px' : 'none',
              background: 'white',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.06)',
              borderRadius: 12,
              overflow: 'hidden'
            }}>
              {/* Calendar Header */}
              <div style={{
                background: '#F8F9FA',
                borderBottom: '1px solid #E5E7EB',
                padding: window.innerWidth <= 480 ? '12px 20px' : '16px 24px',
                borderBottom: '2px solid #F04915'
              }}>
                <div style={{
                  color: '#F04915',
                  fontSize: window.innerWidth <= 480 ? 12 : 14,
                  fontWeight: 600,
                  fontFamily: 'Outfit',
                  textAlign: 'center'
                }}>
                  📅 Calendar
                </div>
              </div>

              {/* Calendar Content */}
              <div style={{ padding: window.innerWidth <= 480 ? '20px' : '24px' }}>
                <div style={{ width: '100%' }}>
                  {/* Calendar Header */}
                  <div style={{
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: window.innerWidth <= 480 ? 16 : 20
                  }}>
                    <button 
                      onClick={prevMonth} 
                      style={{
                        border: 'none', 
                        background: 'transparent', 
                        cursor: 'pointer', 
                        padding: 8,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z" fill="#B5BEC6"/>
                      </svg>
                    </button>
                    
                    <div style={{
                      color: '#4A5660', 
                      fontSize: window.innerWidth <= 480 ? 14 : 16, 
                      fontWeight: 600, 
                      fontFamily: 'Outfit'
                    }}>
                      {formatMonthYear()}
                    </div>
                    
                    <button 
                      onClick={nextMonth} 
                      style={{
                        border: 'none', 
                        background: 'transparent', 
                        cursor: 'pointer', 
                        padding: 8,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 0L0.59 1.41L5.17 6L0.59 10.59L2 12L8 6L2 0Z" fill="#B5BEC6"/>
                      </svg>
                    </button>
                  </div>

                  {/* Day Names */}
                  <div style={{
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(7, 1fr)', 
                    textAlign: 'center', 
                    marginBottom: window.innerWidth <= 480 ? 12 : 16
                  }}>
                    {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(day => (
                      <div key={day} style={{
                        fontSize: window.innerWidth <= 480 ? 9 : 10, 
                        color: '#B5BEC6', 
                        fontWeight: 600,
                        textTransform: 'uppercase', 
                        letterSpacing: '1px',
                        fontFamily: 'Outfit'
                      }}>
                        {day}
                      </div>
                    ))}
                  </div>
                  
                  {/* Calendar Days */}
                  <div style={{
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(7, 1fr)', 
                    gridGap: window.innerWidth <= 480 ? '6px 0' : '8px 0', 
                    textAlign: 'center'
                  }}>
                    {calendar.map((week, weekIndex) => (
                      <React.Fragment key={`week-${weekIndex}`}>
                        {week.map((day, dayIndex) => {
                          const isCurrentDay = isToday(day);
                          
                          return (
                            <div 
                              key={`day-${weekIndex}-${dayIndex}`}
                              style={{
                                height: window.innerWidth <= 480 ? 28 : 32, 
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              {day !== null ? (
                                isCurrentDay ? (
                                  <div style={{
                                    width: window.innerWidth <= 480 ? 26 : 30,
                                    height: window.innerWidth <= 480 ? 26 : 30,
                                    borderRadius: '50%',
                                    backgroundColor: '#F04915',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                    <span style={{
                                      color: 'white',
                                      fontSize: window.innerWidth <= 480 ? 12 : 14,
                                      fontWeight: 600,
                                      fontFamily: 'Outfit'
                                    }}>
                                      {day}
                                    </span>
                                  </div>
                                ) : (
                                  <span style={{
                                    fontSize: window.innerWidth <= 480 ? 12 : 14,
                                    color: '#4A5660',
                                    fontWeight: 500,
                                    fontFamily: 'Outfit'
                                  }}>
                                    {day}
                                  </span>
                                )
                              ) : (
                                <span style={{color: 'transparent'}}>&nbsp;</span>
                              )}
                            </div>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;